module.exports = __webpack_public_path__ + "images/pickup_store_4feca1f3c5c9791e7ed33103cf7f577a.png";